/* eslint-disable import/no-anonymous-default-export */

export default (pending = [], action) => {
  switch (action.type) {
    case "GET_ALL_PENDING_CLAIMS":
      return action.payload;
    case "HEAD_OFFICE_APPROVING_CLAIM":
      return pending.filter((data) => data._id !== action.payload);
    default:
      return pending;
  }
};
